import CheckboxSelectAllController from './checkbox_select_all_controller'

export default class extends CheckboxSelectAllController {
  _shouldToggle(container, checkbox) {
    return container.contains(checkbox) && checkbox.checkVisibility() === true
  }

  _refreshCheckboxAll(checkboxAll, checkboxes, checked) {
    const visibleCheckboxes = Array.from(checkboxes).
      filter((checkbox) => checkbox.checkVisibility())
    const visibleChecked = checked.filter((checkbox) => checkbox.checkVisibility())

    checkboxAll.checked = visibleChecked.length > 0 &&
      visibleChecked.length === visibleCheckboxes.length

    checkboxAll.indeterminate = checked.length > 0 &&
      checked.length < checkboxes.length
  }
}
